import React from 'react';
import { VirtualScrollableArea } from './LayoutVirtualScrollableArea.styles';

export interface LayoutVirtualScrollableAreaProps extends Readonly<{}> {}

export const LayoutVirtualScrollableArea: React.FC<LayoutVirtualScrollableAreaProps> = props => {
  return (
    <VirtualScrollableArea
      width={['100vw', '100%']}
      overflowY="auto"
      height="100%"
      flexDirection="column"
      borderRight={['0px solid', '1px solid']}
      borderColor={['mono3', 'mono3']}
    >
      {props.children}
    </VirtualScrollableArea>
  );
};
